const switchTypes = [
  {
    label: 'Dell Force10MXL10',
    value: 'FORCE_10_MXL_10'
  },
  {
    label: 'Dell S6000',
    value: 'S6000/S4048/Z9100'
  },
  {
    label: 'Cisco Catalyst 3000',
    value: 'CATALYST_3000'
  },
  {
    label: 'Cisco Catalyst 4500',
    value: 'CATALYST_4500'
  },
  {
    label: 'Cisco Catalyst 6500',
    value: 'CATALYST_6500'
  },
  {
    label: 'Cisco Nexus 3k',
    value: 'NEXUS_3K'
  },
  {
    label: 'Cisco Nexus 5k',
    value: 'NEXUS_5K'
  },
  {
    label: 'Cisco Nexus 6k',
    value: 'NEXUS_6K'
  },
  {
    label: 'Cisco Nexus 7k',
    value: 'NEXUS_7K'
  },
  {
    label: 'Cisco Nexus 9k',
    value: 'NEXUS_9K'
  },
  {
    label: 'Cisco VSM (N1K)',
    value: 'null'
  },
  {
    label: 'Juniper EX/QFX',
    value: 'null'
  },
  {
    label: 'Arista Switch SSH',
    value: 'null'
  },
  {
    label: 'Brocade VDX 6740/6940',
    value: 'null'
  },
  {
    label: 'Dell Powerconnect 8024 SSH',
    value: 'null'
  },
  {
    label: 'Cisco ASR/ISR (SD-WAN Assessment)',
    value: 'CISCOASRISR'
  },
  {
    label: 'Cisco Catalyst 9300',
    value: 'CATALYST9300'
  }
];

export default switchTypes;
